import * as React from "react";

export const ArticleTags = ({ article, globals, isMobile, settings }) => {
  const badges = article?.tags || [];

  const {
    tag_background_colour,
    tag_text_colour,
    tag_border_colour,
    tag_style,
    tag_style_mobile,
    tag_padding_horizontal,
    tag_padding_vertical,
    tag_padding_horizontal_mobile,
    tag_padding_vertical_mobile,
    tag_radius,
    tag_border_radius,
    tag_border_width,
    tag_layout,
    tag_spacing,
    tag_spacing_mobile,
    tag_configuration,
    max_tags,
    classes,
    padding_top,
    padding_right,
    padding_bottom,
    padding_left,
    margin_top,
    margin_right,
    margin_bottom,
    margin_left
  } = settings || {};

  // Parse tag configuration from blockSettings
  const parseTagConfiguration = (configText) => {
    if (!configText) return {};
    
    const configurations = {};
    const lines = configText.split('\n').filter(line => line.trim());
    
    lines.forEach(line => {
      const trimmedLine = line.trim();
      if (trimmedLine.includes('=')) {
        const [tag, displayText] = trimmedLine.split('=').map(part => part.trim());
        configurations[tag.toLowerCase()] = displayText;
      } else {
        configurations[trimmedLine.toLowerCase()] = trimmedLine;
      }
    });
    
    return configurations;
  };

  // Get configured tags
  const tagConfiguration = parseTagConfiguration(tag_configuration);
  const maxTags = max_tags;

  // Find matching tags and their display text
  const matchingTags = badges
    .filter(badge => {
      const lowerBadge = badge.toLowerCase();
      return Object.keys(tagConfiguration).some(configTag => 
        lowerBadge === configTag || lowerBadge.startsWith(configTag)
      );
    })
    .slice(0, maxTags)
    .map(badge => {
      const lowerBadge = badge.toLowerCase();
      const matchingConfig = Object.keys(tagConfiguration).find(configTag => 
        lowerBadge === configTag || lowerBadge.startsWith(configTag)
      );
      return matchingConfig ? tagConfiguration[matchingConfig] : badge;
    });

  if (matchingTags.length === 0) {
    return null;
  }

  const getTagClasses = () => {
    const baseClasses = `rounded-${tag_radius === 'rounded' ? 'full' : `[${tag_border_radius}px]`}`;
    const paddingHorizontal = isMobile ? tag_padding_horizontal_mobile : tag_padding_horizontal;
    const paddingVertical = isMobile ? tag_padding_vertical_mobile : tag_padding_vertical;
    const style = isMobile ? tag_style_mobile : tag_style;

    return `
      ${baseClasses}
      ${style}
      w-fit
      border-[${tag_border_width}px]
      px-[${paddingHorizontal}px] py-[${paddingVertical}px]
    `;
  };

  const getTagStyles = () => {
    return {
      backgroundColor: tag_background_colour,
      color: tag_text_colour,
      borderColor: tag_border_colour,
    };
  };

  const getContainerClasses = () => {
    const spacing = isMobile ? tag_spacing_mobile : tag_spacing;
    return `
      flex ${tag_layout} gap-[${spacing}px]
    `;
  };

  const getPaddingMarginClasses = () => {
    return `
      pt-[${padding_top}px]
      pb-[${padding_bottom}px]
      pl-[${padding_left}px]
      pr-[${padding_right}px]
      mt-[${margin_top}px]
      mb-[${margin_bottom}px]
      ml-[${margin_left}px]
      mr-[${margin_right}px]
    `;
  };

  return (
    <>
      <div 
        className={`${getContainerClasses()} ${getPaddingMarginClasses()} ${classes || ''}`}
      >
        {matchingTags.map((tagText, index) => (
          <div
            key={index}
            className={getTagClasses()}
            style={getTagStyles()}
          >
            {tagText}
          </div>
        ))}
      </div>
    </>
  );
};
